import { useState } from 'react';

// P0-7 — inline jargon glossary. A small "?" affordance that expands an
// always-visible explanation on tap/click (NOT hover-only, so it works on
// mobile). Use for terms a non-technical customer won't know: "espelho",
// "caixa de aparelhagem", "módulo", "hub", "neutro".
export function InfoHint({ label, children }: { label?: string; children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="inline-flex flex-col">
      <button
        type="button"
        aria-expanded={open}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        className="inline-flex items-center gap-1 text-[11px] font-medium text-smartify-accent hover:underline"
      >
        <span className="grid h-3.5 w-3.5 place-items-center rounded-full border border-current text-[9px] leading-none">?</span>
        {label ?? 'O que é isto?'}
      </button>
      {open && (
        <span className="mt-1 block rounded-smartify bg-smartify-paper px-2.5 py-1.5 text-[11px] leading-relaxed text-smartify-ink">
          {children}
        </span>
      )}
    </span>
  );
}
